import React from 'react';
import { supabase } from '../lib/supabase';

const DEFAULT_MESSAGE =
  'Sua conta está desativada. O Seu.video está em fase de teste e, por enquanto, o acesso desta organização foi pausado. No futuro a conta será reabilitada.';

export default function AccountDisabled({ message }: { message?: string | null }) {
  return (
    <div className="auth-container">
      <div className="glass-card" style={{ textAlign: 'center' }}>
        <div className="auth-brand">
          <img src="/assets/icon-mark.png" alt="Seu.video" className="auth-brand-mark" />
        </div>
        <h1>Conta desativada</h1>
        <p className="subtitle" style={{ marginBottom: '1.5rem' }}>
          {message?.trim() || DEFAULT_MESSAGE}
        </p>
        <button
          type="button"
          className="btn-primary"
          onClick={() => { void supabase.auth.signOut(); }}
        >
          Sair
        </button>
      </div>
    </div>
  );
}

export function SignupLinkRequired() {
  return (
    <div className="auth-container">
      <div className="glass-card" style={{ textAlign: 'center' }}>
        <div className="auth-brand">
          <img src="/assets/icon-mark.png" alt="Seu.video" className="auth-brand-mark" />
        </div>
        <h1>Link de cadastro necessário</h1>
        <p className="subtitle" style={{ marginBottom: '1.5rem' }}>
          Esta conta ainda não tem uma organização. O cadastro é feito por um link exclusivo.
        </p>
        <button
          type="button"
          className="btn-primary"
          onClick={() => { void supabase.auth.signOut(); }}
        >
          Sair
        </button>
      </div>
    </div>
  );
}
